<template>
  <div>
    <top-header :type="3" :isShow="false" :bgColor="bgColor" :textColor="textColor" />
    <div class="top_banner" ref="topBanner">
      <swiper class="swiper" ref="mySwiper">
        <swiper-slide>
          <swiper class="swiper vertical">
            <swiper-slide class="slide_video_con" v-for="(item, index) in swiperImg" :key="index">
              <img v-lazy="item" alt="">
            </swiper-slide>
          </swiper>
        </swiper-slide>
      </swiper>
      <div class="total">共{{ swiperImg.length }}张</div>
    </div>
    <div class="detail_con new_detail_con">
      <div class="inner m_flex_box flex_vc flex_jz flex_column">
        <div class="case_name">
          {{ info.dataItemName }}
        </div>
        <div class="left_new flex_jz">
          <p>案例风格:<span>{{ info.styleType }}</span></p>
          <p>户型面积:<span>{{ info.areaType }}</span></p>
        </div>
      </div>
    </div>
    <div class="line-sty"></div>
    <div class="detail_con">
      <div class="detail_con line-word">本案设计师简介</div>
      <div class="inner m_flex_box flex_vc flex_jz">
        <img v-lazy="userInfo.logo" alt="" />
        <div class="left flex_v flex_jz">
          <h3 class="line_comp">{{ userInfo.name }}</h3>
          <p>从业经验：{{ userInfo.popularity }}年</p>
          <p class="line_comp2 line_comp3">{{ userInfo.description }}</p>
          <p class="m_flex_box flex_vc line"
            @click="clickOn(userInfo.name, userInfo.decorationCompanyName, userInfo.decorationCompanyId)">
            <span class="">预约设计</span>
          </p>
        </div>
      </div>
    </div>
    <div class="line-sty"></div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="detail_con line-word">相关案例</div>
      <div class="no_data" v-if="!userInfo.decorationDemoList.length">
        <img src="@/assets/img/nodata.png" alt="">
      </div>
      <div class="list_con new_list">
        <div class="detail_con">
          <div class="m_flex_box flex_jz flex_wrap">
            <div class="inner m_flex_box flex_vc flex_jz flex_column" v-for="(item, index) in userInfo.decorationDemoList"
              :key="index" @click="toDetail(item.id, item.decorationUserId)">
              <img class="new_img" v-lazy="item.logo" alt="" />
              <div class="left_new flex_v flex_jz">
                <h3 class="line_comp">
                  <span>{{ item.dataItemName ? item.dataItemName : item.title }} </span>
                  <span>{{ item.areaType }} </span>
                </h3>
                <p class="m_flex_box flex_vc line">
                  <span class="">设计师：{{ userInfo.name }}</span>
                  <span class="">{{ item.styleType }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </van-list>
    <div class="fixed_pad"></div>
    <div class="fix_btn">
      <p @click="consult(userInfo.customerPath)">
        <img src="@/assets/img/zixun.png" alt="" />
        在线咨询
      </p>
      <p @click="zxbm(userInfo.decorationCompanyId, userInfo.decorationCompanyName)">
        <img src="@/assets/img/baoming.png" alt="" />
        在线报名
      </p>
    </div>
  </div>
</template>

<script>
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import qs from "qs";
import topHeader from "@/components/header";
export default {
  name: 'caseDetail',
  data() {
    return {
      swiperImg: [],
      info: {},
      bgColor: 'transparent',
      textColor: '#fff',
      userInfo: {
        decorationDemoList: []
      },
      id: this.$route.query.id,
      userId: this.$route.query.userId,
      list: [],
      listPage: 1,
      loading: false,
      finished: false,
      value: "",
      timer: null
    };
  },
  components: {
    topHeader,
  },

  created() {
    this.getInfo()
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    clickOn(userName, companyName, companyId) {
      this.$router.push({
        path: "/fixtures",
        query: {
          name: userName,
          companyName: companyName,
          companyId: companyId,
        }
      });
    },
    zxbm(companyId, companyName) {
      this.$router.push({
        path: "/fixtures",
        query: {
          companyId: companyId,
          companyName: companyName
        }
      });
    },
    consult(url) {
      window.location.href = url
    },
    getInfo() {
      this.$request_again.post('/decoration/demo/byId', qs.stringify({
        id: this.id
      })
      )
        .then(res => {
          if (res.success) {
            this.info = res.result;
            this.swiperImg = res.result.images.split(",")
          }
        });
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$request_again.post('/decoration/user/byId', qs.stringify({
          id: this.userId
        })
        )
          .then(res => {
            if (res.success) {
              this.userInfo = res.result;
              if (this.userInfo.decorationDemoList) {
                this.userInfo.decorationDemoList.forEach((value, index, array) => {
                  if (value.id == this.id) {
                    array.splice(index, 1)
                  }
                })
              }
              this.loading = false;
              this.finished = true;
              // this.listPage += 1;
            } else {
              this.finished = true;
            }
          });
      }
    },
    toDetail(id, userId) {
      this.$router.push({
        path: "/caseDetail",
        query: {
          id: id,
          userId: userId
        }
      });
    },
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > this.offsetTop - (document.documentElement.clientWidth / 7.5) * 0.9) {
        this.showPad = true
      } else {
        this.showPad = false
      }
      if (scrollTop > (document.documentElement.clientWidth / 7.5) * 5.6) {
        this.textColor = '#000';
        this.bgColor = '#fff';
      } else {
        this.textColor = '#fff';
        this.bgColor = 'transparent';
      }
    },
  }
};
</script>
<style lang="less" scoped>
.top_banner {
  position: relative;
  height: 5.64rem;

  .total {
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 0.24rem;
    width: 1.2rem;
    line-height: 0.5rem;
    position: absolute;
    bottom: 0.24rem;
    right: 0.4rem;
    z-index: 9;
    text-align: center;
    border-radius: 0.25rem;
  }

  img {
    height: 5.64rem;
    width: 100%;
  }

  .slide_video_con {
    position: relative;

    .cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 5.64rem;
      background-color: rgba(0, 0, 0, 0.3);

      i {
        color: #fff;
        font-size: 1.4rem;
      }
    }

  }
}

.case_name {
  padding: 0.2rem 0 0.2rem 0.5rem;
  width: 100%;
  font-size: 0.38rem;
  font-weight: 900;
  text-align: left;
  box-sizing: border-box;
}

.fixed_pad {
  height: 1.2rem
}

.fix_btn {
  background: #fff;
  width: 100%;
  position: fixed;
  height: 0.8rem;
  padding: 0.2rem 0;
  display: flex;
  bottom: 0;
  justify-content: space-around;

  p {
    border-radius: 5px;
    width: 42%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;

    img {
      margin-right: 0.1rem;
      width: 0.3rem;
      height: 0.3rem;
    }

    &:first-child {
      background: #17C5FB;
    }

    &:last-child {
      background: #376BFF
    }
  }
}

.line-sty {
  border: 5px solid #F7F7F7
}

.line-word {
  padding: 0.3rem 0 0 0;
  font-size: 0.35rem;
  font-weight: 900;
}

.line_comp {
  font-weight: 900;
  font-size: 0.35rem;
  padding: 0.1rem;
}

.detail_con {
  width: 7.04rem;
  margin: 0 auto;

  .flex_column {
    flex-direction: column;

    .new_img {
      width: 100%;
      height: 2.45rem;
      border-radius: 5px 5px 0 0;

      p {
        font-size: 0.3rem;
      }
    }
  }

  .pad_top {
    padding-top: 1.1rem;
  }

  .flex_wrap {
    flex-wrap: wrap
  }

  .inner {
    padding: 0.4rem 0;

    .left {
      width: 4.25rem;
      height: 2.98rem;

      h4 {
        height: 0.88rem;
        font-size: 0.28rem;
        color: #202020;
        line-height: 0.44rem;
      }

      p:first-child {
        font-size: 0.32rem;
        font-weight: 600;
      }

      .line {
        display: flex;

        span {
          margin-right: 0.5rem;
          padding: 0.1rem 0.4rem;
          border-radius: 5px;
          color: #fff;
          font-weight: 500;
          font-size: 0.25rem;
          background-color: #2f72f5;
        }
      }

      .line_comp3 {
        -webkit-line-clamp: 3;
      }
    }

    img {
      width: 2.34rem;
      height: 3.08rem;
      object-fit: cover;
    }



  }


}

.new_detail_con {
  width: 100%;

  .inner {
    padding: 0;

    img {
      width: 100%;
      height: auto;
    }
  }

  .left_new {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 0.5rem;
    width: 100%;

    p {
      color: #676767;
      font-size: 0.3rem;
      padding: 0.2rem 0;
      width: 45%;

      span {
        color: #111111;
        margin-left: 0.1rem
      }
    }
  }


}

.new_list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .inner {
    width: 46%;

    .left_new {
      width: 100%;

      .line_comp {
        display: flex;
        justify-content: space-around;

        span {
          width: 48%;
          font-size: 0.26rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .line {
        justify-content: space-around;
      }
    }
  }
}
</style>